import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import '../../node_modules/antd/dist/antd.min.css';
import '../iconfont/iconfont.css';
import { Layout, Modal } from 'antd';
import Home from './Home';
import Ranks from './Ranks';
import FindList from './find/FMList';
import FDetail from './find/FDetail';
import FindMyList from './find/FMyList';
import Login from './Login';
import TrainList from './TrainList';
import RescueList from './RescueList';
import PlayerInfo from './PlayerInfo';
import Feedback from './Feedback';
import Task from './Task';
import SearchResult from './SearchResult';
import Review from './Review';
import Grade from './Grade';
import Mall from './Mall';
import MallManage from './MallManage';
import Notice from './Notice';
import MShoppingCar from './mall/MShoppingCar';
import MOrderList from './mall/MOrderList';
import MOrderDetail from './mall/MOrderDetail';
import BigData from './BigData';
import UpdateLogs from './UpdateLogs';
import Donation from './Donation';
import ScanCode from './other/ScanCode';
import ManualList from './ManualList';
import Manual from './Manual';
import Sign from './Sign';
import NewsList from './NewsList';
import NewsShare from './other/NewsShare';
import BottomMenu from '../BottomMenu';
import EMList from './expert/EMList';
import EList from './expert/EList';
import EDetail from './expert/EDetail';
// import Report from './Report';
import TrainCertificate from './mobile/TrainCertificate';
import BNVideo from './bottomNav/BNVideo';
import SUpdatePlayer from './super/SUpdatePlayer';
import CartIndex from './cart/CartIndex';
import BNProAuthor from './bottomNav/BNProAuthor';
import Insure from './Insure';
import Verification from './teamApplication/PreparatoryTeamApplicationDirectory/Verification'
import Inspection from './Inspection';
import SupervisorEchoList from './inspection/SupervisorEchoList'
import SkillTrain from "./SkillTrain";
import { app } from "../app";

class Index extends Component {

  render() {
    return (
      <Router>
        <Layout style={{ height: '100%', background: 'transparent' }}>
          <Switch>
            {/*<Route path="/m" render={(props)=>{*/}
            {/*// https://blueskyrescue.cn/m/#/i=%E8%B5%A300080003&t=1525758219*/}
            {/*let hash = decodeURI(props.location.hash);*/}
            {/*let paramStr = hash.split('#/')[1];*/}
            {/*let url = 'https://app.blueskyrescue.cn/player-info.html?' + paramStr;*/}
            {/*window.location.href = url;*/}
            {/*return <div>正在跳转···</div>;*/}
            {/*}}/>*/}
            <Route path="/m" component={ScanCode} />
            <Route path="/v" component={Verification} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/login/first" component={Login} />
            <Route exact path="/trainProof" component={TrainCertificate} />
            {/* 报备 */}
            {/*<Route path="/report" render={(props) => <Report {...props}/>}/>*/}
            {/*<Route path="/report" component={Report}/>*/}
            {/* 队伍 */}
            <Route path="/ranks" component={Ranks} />
            {/* 寻人启事 */}
            <Route path="/find" component={FindList} />
            {/* 寻人启事 我的发布 */}
            <Route path="/myfind" component={FindMyList} />
            {/* 寻人启事-游客查看寻人详情 */}
            <Route path="/find-detail/:id" component={FDetail} />
            {/* 救援 */}
            <Route exact path="/trainlist" component={TrainList} />
            {/* 培训 */}
            <Route exact path="/rescuelist" component={RescueList} />
            {/* 反馈 */}
            <Route path="/feedback" component={Feedback} />
            {/* 个人中心 */}
            <Route path="/player" component={PlayerInfo} />
            {/* 任务 */}
            <Route path="/task" component={Task} />
            {/* 搜索结果 */}
            <Route exact path="/search-result/:search_type/:search_val" component={SearchResult} />
            {/* 审核 */}
            <Route path="/review" component={Review} />
            {/* 商城 */}
            <Route exact path="/mall/shopping-car" component={MShoppingCar} />
            <Route exact path="/mall/orders" component={MOrderList} />
            <Route exact path="/mall/order-detail/:id" component={MOrderDetail} />
            <Route path="/mall" component={Mall} />
            {/* 商城管理 */}
            <Route path="/mall-manage" component={MallManage} />
            {/* 通知 */}
            <Route path="/notice" component={Notice} />
            {/* 地区设定 */}
            <Route path="/grade" component={Grade} />
            {/* 存心大数据 */}
            <Route path="/bigdata" component={BigData} />
            {/* 更新日志 */}
            <Route path="/update_log" component={UpdateLogs} />
            {/* 捐赠 */}
            <Route path="/donation" component={Donation} />
            {/* 使用手册管理 */}
            <Route path="/manual-manage" component={ManualList} />
            {/* 使用手册 */}
            <Route path="/manual" component={Manual} />
            {/* 签到 */}
            <Route path="/sign" component={Sign} />
            {/* 新闻 */}
            <Route path="/news" component={NewsList} />
            {/* 新闻 */}
            <Route path="/news-share/:id" component={NewsShare} />
            {/* 展播视频 */}
            <Route path="/videos" component={BNVideo} />
            {/* 产品授权 */}
            <Route path="/pro-author/:name" component={BNProAuthor} />
            {/* 其它页面 */}
            <Route path="/other/:name" component={BottomMenu} />
            {/* 专家库管理页面 */}
            <Route path="/expert-manage" component={EMList} />
            {/* 专家库页面 */}
            <Route path="/expert" component={EList} />
            <Route path="/expert-detail/:id" component={EDetail} />
            {/* 保险 */}
            <Route path="/insure" component={Insure} />
            {/* 超级管理员修改队员 姓名、身份证号、解绑小程序 */}
            <Route path="/super-updatePlayer" component={SUpdatePlayer} />
            <Route path="/cart_index" component={CartIndex} />
            {/*技能培训*/}
            <Route path="/skillTrain" component={SkillTrain} />
            {/* 互联网+督查 */}
            <Route exact path="/Inspection" component={Inspection} />
            <Route path="/Inspection/supervisorEchoList" component={SupervisorEchoList}></Route>
            {/* 首页 */}
            <Route exact path="/" component={Home} />
            <Route render={() => {
              return (<Redirect to="/" />);
            }} />
          </Switch>
        </Layout>
      </Router>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/routes/Index.jsx